'use client';

import { useEffect, useMemo, useState } from 'react';
import { Play } from 'lucide-react';

import MiniWaveform from './mini-waveform-mockup';

// Step 3: Voice Selection
export default function VoiceLibraryMockup() {
  const voices = useMemo(
    () => [
      { name: 'Sarah', accent: 'US English', initials: 'S' },
      { name: 'James', accent: 'UK English', initials: 'J' },
      { name: 'Maria', accent: 'Spanish', initials: 'M' },
      { name: 'Hans', accent: 'German', initials: 'H' }
    ],
    []
  );

  const [selectedVoice, setSelectedVoice] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedVoice((prev) => (prev + 1) % voices.length);
      setIsPlaying(true);
      setTimeout(() => setIsPlaying(false), 1800);
    }, 2500);
    return () => clearInterval(interval);
  }, [voices.length]);

  return (
    <div className="w-full h-[320px] bg-background p-5">
      <div className="h-full flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="text-sm font-medium text-foreground">
            Select Voice
          </div>
          <span className="text-xs text-videomule-green font-medium bg-videomule-light-green px-2.5 py-1 rounded-full">
            100+ voices
          </span>
        </div>

        {/* Voice grid */}
        <div className="flex-1 grid grid-cols-2 gap-3">
          {voices.map((voice, i) => (
            <div
              key={i}
              className={`rounded-xl border p-3 transition-all duration-300 flex flex-col ${
                i === selectedVoice
                  ? 'border-videomule-green bg-videomule-light-green shadow-md scale-[1.02]'
                  : 'border-border bg-card'
              }`}
            >
              <div className="flex items-center gap-2.5 mb-2">
                <div className="w-9 h-9 rounded-full bg-gradient-to-br from-videomule-green to-videomule-green-hover flex items-center justify-center shadow">
                  <span className="text-white text-sm font-bold">
                    {voice.initials}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground">
                    {voice.name}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {voice.accent}
                  </p>
                </div>
              </div>

              <div
                className={`flex-1 rounded-lg flex items-center justify-center min-h-[36px] ${
                  i === selectedVoice
                    ? 'bg-white/60 dark:bg-background/40'
                    : 'bg-muted/30'
                }`}
              >
                {i === selectedVoice && isPlaying ? (
                  <div className="w-full h-6 px-2">
                    <MiniWaveform
                      bars={20}
                      active={true}
                    />
                  </div>
                ) : (
                  <div className="flex items-center gap-1.5 text-muted-foreground">
                    <Play className="w-3 h-3" />
                    <span className="text-xs">Preview</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
